const CorsicaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111227)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FCFCFC"
      />
      <path
        d="M26.9638 16.9402C26.9638 12.7102 23.5347 9.28125 19.3048 9.28125C16.1834 9.28125 13.5 11.1492 12.3069 13.8277L11.3623 17.2523L12.2318 18.1218L10.4927 21.6001L12.2318 22.4696L11.3623 23.3391V24.2087L12.2318 25.0782V26.8173L13.1013 27.6869L15.71 26.8173C15.71 26.8173 15.71 27.6869 16.5796 28.5565C17.4491 29.426 18.3188 31.1652 18.3188 31.1652C18.3188 31.1652 20.9274 32.0348 22.6666 29.4261C24.4057 26.8174 26.1449 25.9478 26.1449 25.9478L24.4686 22.5952C26.0016 21.1949 26.9638 19.1803 26.9638 16.9402Z"
        fill="black"
      />
      <path
        d="M27.5878 19.8697C31.1213 19.2737 31.7099 12.3545 31.7099 12.3545H26.8404C29.3621 18.4414 26.7227 18.8509 26.7227 18.8509C26.3651 18.5849 13.5684 12.5227 13.1628 12.3686C13.065 12.4993 12.7053 12.8429 12.2679 13.9124C11.8305 14.9819 11.7231 15.9441 11.7231 15.9441C11.928 16.0776 25.5181 20.823 25.8773 20.8625C26.5902 21.3286 27.4674 22.7225 26.9771 26.8551L31.6642 25.5342C31.6643 25.5342 30.0736 21.3027 27.5878 19.8697Z"
        fill="#ACABB1"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111227">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CorsicaSvg;
